var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTyre(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 33.8C12.35 33.8 6.2 27.5999 6.2 20C6.2 12.35 12.4001 6.2 20 6.2C27.6001 6.2 33.8 12.3499 33.8 20C33.8 27.6501 27.6501 33.8 20 33.8ZM20 0C8.95 0 0 8.95 0 20C0 31.05 8.95 40 20 40C31.05 40 40 31.05 40 20C40 8.95 31.05 0 20 0Z",
    fill: "#27509F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9999 24C17.7998 24 15.9998 22.2 15.9998 19.9999C15.9998 17.7998 17.7998 15.9998 19.9999 15.9998C22.2 15.9998 24 17.7998 24 19.9999C24 22.2 22.2 24 19.9999 24ZM32.4499 19.0499C32.2999 16.9998 31.6498 15.0498 30.6 13.3998C28.5 15.9999 25.3001 16.8997 23.2998 15.4499C21.2497 13.9498 21.15 10.6497 22.9496 7.84982C21.9996 7.65 20.9996 7.5 19.9997 7.5C18.9998 7.5 17.9999 7.65 17.0498 7.85018C18.8498 10.6501 18.7497 13.9502 16.6996 15.4503C14.6496 16.9504 11.4496 16.0003 9.39947 13.4002C8.34929 15.0502 7.69956 17.0002 7.54956 19.0503C10.7496 18.2003 13.8996 19.3502 14.6496 21.7003C15.4496 24.1002 13.5496 26.8503 10.4496 28.0504C11.7496 29.5504 13.3996 30.8004 15.2498 31.5503C15.3998 28.2502 17.4499 25.6002 19.9997 25.6002C22.5496 25.6002 24.5498 28.2502 24.7496 31.5503C26.5996 30.8004 28.2496 29.6003 29.5498 28.0504C26.4499 26.8503 24.5997 24.1005 25.3499 21.7003C26.1497 19.3499 29.2499 18.2 32.4499 19.0499Z",
    fill: "#27509F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.45 19.9999C22.45 21.3531 21.3531 22.45 19.9999 22.45C18.6467 22.45 17.5498 21.3531 17.5498 19.9999C17.5498 18.6467 18.6467 17.5498 19.9999 17.5498C21.3531 17.5498 22.45 18.6467 22.45 19.9999Z",
    fill: "#27509F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTyre);
export default __webpack_public_path__ + "static/media/tyre.e26973a320a23c9cec1365746abc58f1.svg";
export { ForwardRef as ReactComponent };